import React, { useEffect, useState } from "react";
import Button from "../../../components/Button";
import CardLayout from "../../../components/CardLayout";
import Input from "../../../components/Input";
import ScreenShot from "../../../components/ScreensShot/ScreenShot";
import { Notification } from "../../../components/ToastNotification";
import { fundTransferValidate } from "../../../components/Validation/vaildate";
import { useGetLoginUserQuery } from "../../../Services/userApi";
import {
  useGetAllWalletQuery,
  useTransferFundMutation,
} from "../../../Services/walletApi";

const FundTransferPage = () => {
  const { data: allWalletInfo } = useGetAllWalletQuery();
  const { data: userData } = useGetLoginUserQuery();
  const [formErrors, setFormErrors] = useState({}); // form errors
  const [showTrxField, setShowTrxField] = useState(false);
  const [data, setData] = useState({
    receiver_id: "",
    amount: "",
    trx_password: "",
  });
  // // error
  useEffect(() => {
    setFormErrors(fundTransferValidate(data));
  }, [data]);
  const [addtransferFund, { error, data: fundData, isLoading }] =
    useTransferFundMutation();
  useEffect(() => {
    if (fundData?.message) {
      Notification(fundData?.message, "success");
      setData({
        receiver_id: "",
        amount: "",
        trx_password: "",
      });
      setShowTrxField(false);
    } else {
      Notification(error?.data?.message, "error");
    }
  }, [error, fundData]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.keys(formErrors).length > 0) {
      Notification("All conditions and fields are required", "error");
      setShowTrxField(false);
    } else {
      if (!data.trx_password) {
        Notification("Transaction password is required", "error");
        setShowTrxField(true);
      } else {
        const dataU = {
          ...data,
          user_id: userData?.data?.user_id,
          receiver_id: data.receiver_id?.toUpperCase(),
        };
        if (dataU.amount < 0) {
          Notification("Negative amount is not allow", "error");
        } else {
          // console.log(dataU);
          await addtransferFund(dataU);
        }
      }
    }
  };
  // const trx = parseFloat(allWalletInfo?.total_deposite);
  const total_amount =
    parseInt(allWalletInfo?.total_deposite) +
    parseFloat(allWalletInfo?.total_income);
  const trx_amount = (total_amount * 17)?.toFixed(2);
  return (
    <div className="tronliveClub_topupaccount_page_wrapper">
      <ScreenShot width={600} height={400} pageName={"transfer-fund"} />
      <CardLayout
        style={{ backgroundColor: "#fff" }}
        className="tronliveClub_topupaccount_form_card"
      >
        <div className="tronliveClub_section_title">
          <h2>Fund Transfer</h2>
          <div className="tronliveClub_section_title_right_side">
            <div className="tronliveClub_section_title_balance tronliveClub_section_Trx_balance">
              <p>TRX: {parseInt(trx_amount)?.toFixed(3)}</p>
            </div>
            <div className="tronliveClub_section_title_balance">
              <p>USD: {`$${total_amount ? parseInt(total_amount)?.toFixed(3) : "0"}`}</p>
            </div>
          </div>
        </div>
        <div className="tronliveClub_topupaccount_page_content">
          <form onSubmit={handleSubmit}>
            <div className="form_group">
              <Input
                label="Receiver user id"
                type="text"
                name="receiver_id"
                value={data.receiver_id}
                placeholder="Enter your receiver user id"
                onChange={(e) =>
                  setData({ ...data, receiver_id: e.target.value })
                }
                className="input_field"
                inputGroupClass="left"
                isRequired={true}
              />
              <Input
                label="Amount"
                type="number"
                name="amount"
                value={data.amount}
                placeholder="Enter your amount"
                onChange={(e) => setData({ ...data, amount: e.target.value })}
                className="input_field"
                inputGroupClass="right amount_field"
                isRequired={true}
              />
            </div>
            {showTrxField && (
              <div className="form_group">
                <Input
                  label="Your Transaction Password"
                  type="text"
                  name="trx_password"
                  value={data.trx_password}
                  placeholder="Enter your transaction password"
                  onChange={(e) =>
                    setData({ ...data, trx_password: e.target.value })
                  }
                  className="input_field"
                  inputGroupClass="left"
                  isRequired={true}
                />
                <Input
                  label=""
                  type="text"
                  name=""
                  placeholder=""
                  className="input_field"
                  inputGroupClass="right"
                  isRequired={false}
                  disabled={true}
                  style={{ display: "none" }}
                />
              </div>
            )}
            <Button type="submit" className="submit_btn" disabled={isLoading}>
              {isLoading ? "Loading..." : "Fund Transfer"}
            </Button>
          </form>
        </div>
      </CardLayout>
    </div>
  );
};

export default FundTransferPage;
